module.exports = __webpack_public_path__ + "static/img/quarte-riposte-logos-512x512-clear.3d14aec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quarte-riposte-logos-512x512-clear.png
// module id = 387
// module chunks = 1